import { useState } from "react";
import { TabPane } from "reactstrap";
import { LI, UL } from "../../../../AbstractElements";
import SentPushNotificationContent from "./SentPushNotificationContent";
import { useNavigate } from "react-router-dom";
import { PushNotificationData } from "../types";
import PushNotificationDetail from "./PushNotificationDetail";
import CommunicationPagination from "../../CommunicationPagination";

interface SentContentProps {
  pushNotifications: PushNotificationData[];
  searchWord: string;
}

const SentContent: React.FC<SentContentProps> = ({
  pushNotifications,
  searchWord,
}) => {
  const navigate = useNavigate();
  const [selectedPushNotification, setSelectedPushNotification] =
    useState<PushNotificationData | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);

  const filteredPushNotifications = pushNotifications.filter(
    (notification) =>
      notification.recipientRoles.some((role) =>
        role.toLowerCase().includes(searchWord.toLowerCase())
      ) ||
      notification.title.toLowerCase().includes(searchWord.toLowerCase()) ||
      notification.message.toLowerCase().includes(searchWord.toLowerCase()) ||
      notification.notificationType
        ?.toLowerCase()
        .includes(searchWord.toLowerCase())
  );

  const paginatedPushNotifications = filteredPushNotifications.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handlePushNotificationClick = (notification: PushNotificationData) => {
    navigate(
      `${process.env.PUBLIC_URL}/communication/push-notification-details`,
      {
        state: { notification },
      }
    );
  };

  const handleBack = () => {
    setSelectedPushNotification(null);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <TabPane tabId="2">
      {selectedPushNotification ? (
        <PushNotificationDetail
          notification={selectedPushNotification}
          onBack={handleBack}
        />
      ) : (
        <>
          <div className="mail-body-wrapper">
            <UL className="simple-list">
              {paginatedPushNotifications.map((notification, i) => (
                <LI
                  className="inbox-data"
                  key={i}
                  onClick={() => handlePushNotificationClick(notification)}
                  style={{ cursor: "pointer" }}
                >
                  <SentPushNotificationContent data={notification} i={i} />
                </LI>
              ))}
            </UL>
          </div>
          <CommunicationPagination
            currentPage={currentPage}
            pageSize={pageSize}
            totalItems={filteredPushNotifications.length}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </TabPane>
  );
};

export default SentContent;
